import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

// Import Lucide icons
import {
  Edit3,
  Trash2,
  Plus,
  Video,
  FileText,
  Calendar,
  User,
  ChevronLeft,
  ChevronRight,
  Download,
  Filter,
  Search,
  Eye,
  X,
  PlayCircle,
  Folder,
  Clock,
  Upload,
} from "lucide-react";

import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import { Modal } from "react-bootstrap";
import { AddVideoLink } from "./addVideoLink";
import { EditVideoLink } from "./editVideoLink";
import moment from "moment";

import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import "./AdminVideo.css";
import { useAlert } from "react-alert";

function AdminVideo({ match }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [inputData, setInputData] = useState({
    category: "beginner",
  });

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (item) => {
    setSelectedData(item);
    setShowEdit(true);
  };

  const getVideo = async () => {
    try {
      let payload = {
        page: page,
        category: inputData?.category || "",
      };
      setLoader(true);
      const postData = await api.videoGetAdmin(payload);
      setData(postData.video || []);
      setFilteredData(postData.video || []);
      setnoOfPost(postData.count);
      setLimit(postData.limit);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const deleteBroadcast = async (id) => {
    try {
      let payload = {
        id: id,
      };
      setLoader(true);
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this item?",
      );
      if (isConfirmed) {
        const userData = await api.videoDelete(payload);
        console.log("deleted");
        getVideo();
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    if (value === "") {
      setFilteredData(data);
    } else {
      const filtered = data.filter(
        (item) =>
          item?.title?.toLowerCase().includes(value) ||
          item?.category?.toLowerCase().includes(value) ||
          item?.description?.toLowerCase().includes(value),
      );
      setFilteredData(filtered);
    }
  };

  useEffect(() => {
    getVideo();
  }, [page, inputData]);

  const handleReset = () => {
    setInputData({});
  };

  return (
    <>
      <div className="admin-video-container">
        {/* Header Section */}
        <div className="video-header">
          <div className="content-header">
            <div className="header-left">
              <div className="header-icon-wrapper">
                <Video size={50} className="header-icon" />
              </div>
              <div className="header-title-wrapper">
                <h1 className="header-title">Video Management</h1>
                <span className="video-count">{noOfPost} videos</span>
              </div>
            </div>
            <div className="header-right">
              <div className="search-box">
                <Search size={20} className="search-icon" />
                <input
                  type="text"
                  placeholder="Search videos by title, category, or description..."
                  value={searchTerm}
                  onChange={handleSearch}
                  className="search-input"
                />
              </div>
              <button className="add-video-btn" onClick={handleShow}>
                <Plus size={20} />
                <span>Add Video</span>
              </button>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="stats-container">
          <div className="card-stat">
            <div className="stat-icon total">
              <Video size={28} />
            </div>
            <div className="stat-content">
              <span className="stat-value">{noOfPost}</span>
              <span className="label-stat">Total Videos</span>
            </div>
          </div>
          {/* <div className="card-stat">
            <div className="stat-icon categories">
              <Folder size={28} />
            </div>
            <div className="stat-content">
              <span className="stat-value">
                {
                  [...new Set(data.map((item) => item?.category))].filter(
                    Boolean,
                  ).length
                }
              </span>
              <span className="label-stat">Categories</span>
            </div>
          </div> */}
          <div className="card-stat">
            <div className="stat-icon-wrapper recent">
              <Clock size={28} />
            </div>
            <div className="stat-content">
              <span className="stat-value">
                {data.length > 0
                  ? moment(data[0]?.createdAt).format("MMM D")
                  : "-"}
              </span>
              <span className="label-stat">Last Added</span>
            </div>
          </div>
        </div>

        {/* Table Section */}
        {/* Filter Section */}
        <div className="row filter-section mb-4">
          <div className="col-12">
            <div className="filter-card">
              <div className="filter-header">
                <div className="filter-label">
                  <i className="fas fa-filter"></i> Filter By Category
                </div>
              </div>
              <div className="filter-body">
                <div className="row ">
                  <div className="col-lg-3 col-8">
                    <div className="filter-group">
                      <div className="select-wrapper">
                        <i className="fas fa-caret-down select-arrow"></i>
                        <select
                          name="category"
                          onChange={(e) =>
                            setInputData({
                              ...inputData,
                              category: e.target.value,
                            })
                          }
                          value={inputData?.category || ""}
                          className="form-control"
                        >
                          {/* <option value="">Select Category</option> */}
                          <option value="beginner">Beginner</option>
                          <option value="advance">Advance</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-lg-3 col-4">
                    <button
                      className="themeBlackBtn"
                      onClick={() => handleReset()}
                    >
                      <i className="fas fa-redo"></i> Reset Filters
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="table-section">
          <div className="section-header">
            <h3 className="section-title">Video Library</h3>
            <div className="section-actions">
              <span className="filter-count">
                Showing {filteredData.length} of {noOfPost} videos
              </span>
            </div>
          </div>
          <div className="table-container">
            <Table
              data={filteredData}
              setPage={setPage}
              page={page}
              noOfPost={noOfPost}
              limit={limit}
              deleteBroadcast={deleteBroadcast}
              handleShowEdit={handleShowEdit}
              isEmpty={filteredData.length === 0}
              searchTerm={searchTerm}
              getVideo={getVideo}
              setData={setData}
              setLoader={setLoader}
            />
          </div>
        </div>
      </div>

      {loader && <Loader />}

      {/* Add Video Modal */}
      <Modal
        show={show}
        size="lg"
        onHide={handleClose}
        centered
        className="modern-modal"
      >
        <Modal.Body>
          <div className="modal-content-wrapper">
            <div className="modal-header">
              <h2 className="modal-title">Add New Video</h2>
              <button className="close-modal-btn" onClick={handleClose}>
                <X size={24} />
              </button>
            </div>
            <div className="modal-body-content">
              <AddVideoLink
                getVideo={getVideo}
                setShow={setShow}
                videoData={selectedData}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Edit Video Modal */}
      <Modal
        show={showEdit}
        size="lg"
        onHide={handleCloseEdit}
        centered
        className="modern-modal"
      >
        <Modal.Body>
          <div className="modal-content-wrapper">
            <div className="modal-header">
              <h2 className="modal-title">Edit Video</h2>
              <button className="close-modal-btn" onClick={handleCloseEdit}>
                <X size={24} />
              </button>
            </div>
            <div className="modal-body-content">
              <EditVideoLink
                getVideo={getVideo}
                setShow={setShowEdit}
                videoData={selectedData}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

const Table = ({
  data,
  page,
  setPage,
  noOfPost,
  limit,
  deleteBroadcast,
  handleShowEdit,
  isEmpty,
  searchTerm,
  getVideo,
  setLoader,
}) => {
  const handleChange = (event, value) => {
    setPage(value);
  };
  const alert = useAlert();

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMM Do, YYYY h:mm A");
    return dateTemp;
  };

  const onDragEnd = async (result) => {
    if (!result.destination) return;

    const sourceIndex = result.source.index;
    const destIndex = result.destination.index;

    if (sourceIndex === destIndex) return;

    const draggedItem = data[sourceIndex];

    // optimistic UI update
    // const newData = Array.from(data);
    // const [moved] = newData.splice(sourceIndex, 1);
    // newData.splice(destIndex, 0, moved);
    // setData(newData);
    const globalOrder = (page - 1) * limit + destIndex + 1;
    try {
      setLoader(true);
      // update ONLY dragged item
      await api.updateVideoOrder({
        _id: draggedItem._id,
        order: globalOrder,
      });
      getVideo();
    } catch (err) {
      console.error(err);
      alert.error("Failed to update order");
    }
  };

  return (
    <>
      <div className="modern-table-wrapper">
        <div className="table-responsive">
          <DragDropContext onDragEnd={onDragEnd}>
            <table className="modern-table">
              <thead>
                <tr>
                  <th className="table-header">
                    <div className="header-cell">
                      <Video size={16} />
                      <span>Title</span>
                    </div>
                  </th>
                  <th className="table-header">
                    <div className="header-cell">
                      <Folder size={16} />
                      <span>Category</span>
                    </div>
                  </th>
                  <th className="table-header">
                    <div className="header-cell">
                      <PlayCircle size={16} />
                      <span>Video</span>
                    </div>
                  </th>
                  <th className="table-header">
                    <div className="header-cell">
                      <FileText size={16} />
                      <span>Description</span>
                    </div>
                  </th>
                  <th className="table-header">
                    <div className="header-cell">
                      <Download size={16} />
                      <span>File</span>
                    </div>
                  </th>
                  <th className="table-header">
                    <div className="header-cell">
                      <span>Order</span>
                    </div>
                  </th>
                  <th className="table-header">
                    <div className="header-cell">
                      <User size={16} />
                      <span>Created By</span>
                    </div>
                  </th>
                  <th className="table-header">
                    <div className="header-cell">
                      <Calendar size={16} />
                      <span>Created At</span>
                    </div>
                  </th>
                  <th className="table-header">
                    <div className="header-cell">
                      <span>Actions</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <Droppable droppableId="videoTable" direction="vertical">
                {(provided) => (
                  <tbody ref={provided.innerRef} {...provided.droppableProps}>
                    {isEmpty ? (
                      <tr className="empty-table-row">
                        <td colSpan="9">
                          <div className="empty-state">
                            <div className="empty-icon">
                              <Video size={48} />
                            </div>
                            <h3 className="empty-title">
                              {searchTerm
                                ? "No matching videos found"
                                : "No videos yet"}
                            </h3>
                            <p className="empty-description">
                              {searchTerm
                                ? "Try adjusting your search terms"
                                : "Get started by adding your first video"}
                            </p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      data.map((item, key) => (
                        <Draggable
                          key={item._id}
                          draggableId={item._id}
                          index={key}
                        >
                          {(provided, snapshot) => (
                            <tr
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className={`table-row ${snapshot.isDragging ? "dragging" : ""}`}
                              style={{
                                ...provided.draggableProps.style,
                                display: snapshot.isDragging
                                  ? "table"
                                  : "table-row", // Fixes table row width collapse
                              }}
                            >
                              <td className="table-cell">
                                <div className="cell-content">
                                  <span className="cell-text">
                                    {item?.title || "-"}
                                  </span>
                                </div>
                              </td>
                              <td className="table-cell">
                                <span className="category-badge">
                                  {item?.category || "Uncategorized"}
                                </span>
                              </td>
                              <td className="table-cell">
                                {item?.video ? (
                                  <div className="video-preview">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item?.video,
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <span className="no-video">No video</span>
                                )}
                              </td>
                              <td className="table-cell">
                                {item?.description ? (
                                  <div className="description-preview">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          item?.description?.length > 100
                                            ? item?.description.substring(
                                                0,
                                                100,
                                              ) + "..."
                                            : item?.description,
                                      }}
                                    />
                                  </div>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td className="table-cell">
                                {item?.pdfFile ? (
                                  <a
                                    href={`${process.env.REACT_APP_S3URL}/${item?.pdfFile}`}
                                    download={item?.pdfFile.split("_")[0]}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="file-download-link"
                                  >
                                    <FileText size={16} />
                                    <span className="file-name">
                                      {item?.pdfFile.split("_")[0]}
                                    </span>
                                    <Download size={14} />
                                  </a>
                                ) : (
                                  <span className="no-file">-</span>
                                )}
                              </td>
                              <td className="table-cell">
                                <span className="order-badge">
                                  {item?.order || 0}
                                </span>
                              </td>
                              <td className="table-cell">
                                <div className="cell-content">
                                  <User size={16} className="cell-icon" />
                                  <span className="cell-text">
                                    {item?.createdBy?.email || "-"}
                                  </span>
                                </div>
                              </td>
                              <td className="table-cell">
                                <div className="cell-content">
                                  <Calendar size={16} className="cell-icon" />
                                  <span className="cell-text">
                                    {formatDate(item?.createdAt)}
                                  </span>
                                </div>
                              </td>
                              <td className="table-cell">
                                <div className="action-buttons">
                                  <button
                                    className="action-btn edit-btn"
                                    onClick={() => handleShowEdit(item)}
                                    title="Edit"
                                  >
                                    <Edit3 size={18} />
                                  </button>
                                  <button
                                    className="action-btn delete-btn"
                                    onClick={() => deleteBroadcast(item?._id)}
                                    title="Delete"
                                  >
                                    <Trash2 size={18} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          )}
                        </Draggable>
                      ))
                    )}
                    {provided.placeholder}
                  </tbody>
                )}
              </Droppable>
            </table>
          </DragDropContext>
        </div>

        {/* Pagination - Show only when there's data */}
        {!isEmpty && data.length > 0 && (
          <div className="pagination-container">
            <div className="pagination-info">
              Showing {(page - 1) * limit + 1} -{" "}
              {Math.min(page * limit, noOfPost)} of {noOfPost} videos
            </div>
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfPost / limit)}
                page={page}
                onChange={handleChange}
                shape="rounded"
                color="primary"
                size="large"
                sx={{
                  "& .MuiPaginationItem-root": {
                    fontSize: "14px",
                    fontWeight: 500,
                  },
                  "& .Mui-selected": {
                    background:
                      "linear-gradient(135deg, #4f46e5 0%, #6366f1 100%) !important",
                    color: "white",
                  },
                }}
              />
            </Stack>
          </div>
        )}
        <style jsx="true">{`
          /* Add this to your existing CSS to fix drag styling */
          .table-row.dragging {
            background: #ffffff;
            display: table;
            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
            outline: 2px solid #4f46e5;
            z-index: 9999;
          }
        `}</style>
      </div>

      <style jsx="true">{`
        .modern-table-wrapper {
          padding: 0;
        }

        .modern-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0;
          min-width: 1200px;
        }

        .table-header {
          background: #f1f5f9;
          padding: 20px 16px;
          text-align: left;
          font-size: 13px;
          font-weight: 600;
          color: #475569;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border-bottom: 2px solid #e2e8f0;
        }

        .header-cell {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .table-row {
          transition: background-color 0.2s ease;
          border-bottom: 1px solid #f1f5f9;
        }

        .table-row:hover {
          background-color: #f8fafc;
        }

        .empty-table-row {
          border-bottom: none;
        }

        .empty-table-row:hover {
          background-color: transparent;
        }

        .table-cell {
          padding: 20px 16px;
          vertical-align: middle;
          border-bottom: 1px solid #f1f5f9;
        }

        .cell-content {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .cell-icon {
          color: #94a3b8;
          flex-shrink: 0;
        }

        .cell-text {
          color: #1e293b;
          font-size: 15px;
          font-weight: 500;
          line-height: 1.4;
        }

        .category-badge {
          display: inline-block;
          padding: 6px 16px;
          background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
          color: #4f46e5;
          border-radius: 20px;
          font-size: 13px;
          font-weight: 600;
          text-transform: capitalize;
          border: 1px solid rgba(79, 70, 229, 0.1);
        }

        .order-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
          color: #475569;
          border-radius: 10px;
          font-weight: 700;
          font-size: 15px;
          border: 1px solid #e2e8f0;
        }

        .video-preview {
          width: 200px;
          max-width: 200px;
          border-radius: 12px;
          overflow: hidden;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
        }

        .video-preview iframe {
          width: 100%;
          height: 120px;
          border: none;
          display: block;
        }

        .no-video {
          color: #94a3b8;
          font-style: italic;
          font-size: 14px;
        }

        .description-preview {
          max-width: 250px;
          color: #64748b;
          font-size: 14px;
          line-height: 1.5;
        }

        .file-download-link {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 10px 16px;
          background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
          color: #0369a1;
          text-decoration: none;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.3s ease;
          border: 1px solid rgba(3, 105, 161, 0.1);
        }

        .file-download-link:hover {
          background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(3, 105, 161, 0.1);
        }

        .file-name {
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .no-file {
          color: #94a3b8;
        }

        .action-buttons {
          display: flex;
          gap: 10px;
        }

        .action-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border: none;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          border: 1px solid transparent;
        }

        .edit-btn {
          background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
          color: #0369a1;
          border-color: rgba(3, 105, 161, 0.1);
        }

        .edit-btn:hover {
          background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(3, 105, 161, 0.1);
        }

        .delete-btn {
          background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
          color: #dc2626;
          border-color: rgba(220, 38, 38, 0.1);
        }

        .delete-btn:hover {
          background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(220, 38, 38, 0.1);
        }

        .pagination-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 24px 32px;
          border-top: 1px solid #e2e8f0;
          background: #f8fafc;
        }

        .pagination-info {
          color: #64748b;
          font-size: 14px;
          font-weight: 500;
        }

        @media (max-width: 1200px) {
          .modern-table-wrapper {
            overflow-x: auto;
          }

          .modern-table {
            min-width: 1200px;
          }
        }
      `}</style>
    </>
  );
};

export default AdminVideo;
